export const VENDOR_PORTAL_PATHS = {
  DEFAULT: ":regionId/listing/:propertyId",
  OVERVIEW: "",
  AGENT_UPDATES: "agent-updates",
  EVENTS: "events",
  EVENT: "events/:eventId",
  FEEDBACK: "feedback",
  PERFORMANCE: "performance",
  OFFERS: "offers",
  MARKETING: "marketing",
  DOCUMENTS: "documents",
} as const;
